import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {SelectCustomEvent} from '@ionic/angular';
import {NcCodice} from '../../../_models/NcCodice';
import {SaveMessage} from '../../../_helpers/save-message';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {SearchResult} from '../../../_models/SearchResult';
import {NonconformeService} from '../../../_services/nonconforme.service';

@Component({
    selector: 'app-select-nccodici',
    templateUrl: './select-nccodici.component.html',
    styleUrls: ['./select-nccodici.component.scss'],
    standalone: false
})
export class SelectNccodiciComponent  implements OnInit, OnChanges {
  @Input() idCodNC: number;
  // Contesto di pertinenza (feature 116, issue #3350): 0 = nessun filtro, che è il comportamento
  // predefinito di ogni punto che non lo valorizza esplicitamente. Nessuna regola di dominio qui:
  // il filtro è applicato lato server, il componente rende ciò che riceve.
  @Input() risorsaId = 0;
  @Output() idCodNCChange = new EventEmitter<number>();
  @Output() idChange = new EventEmitter<number>();
  ncCodici: NcCodice[] = [];
  loading = false;
  constructor(
    private saveMessage: SaveMessage,
    private nonconformeService: NonconformeService,
    private organizzazioniService: OrganizzazioniService) { }

  ngOnInit() {
    this.getNCCodici();
  }

  // La card che contiene la tendina compare solo a esito NON CONFORME: il contesto risorsa può
  // quindi cambiare dopo la prima visualizzazione e l'elenco va ricaricato (FR-012).
  // La guardia su firstChange non è opzionale: Angular valorizza gli @Input PRIMA di ngOnInit,
  // quindi senza di essa ogni apertura produrrebbe due chiamate HTTP identiche.
  ngOnChanges(changes: SimpleChanges) {
    if (changes['risorsaId'] && !changes['risorsaId'].firstChange) {
      this.getNCCodici();
    }
  }

  getNCCodici = () => {
    this.loading = true;
    // Anagrafica locale: solo codici attivi e collegati a ESOLVER (utilizzabili per NcScheda)
    this.nonconformeService.getNcCodiciLocali(this.organizzazioniService.organizzazioneId,
      '', 0, 0, 'codice', true, true, true, this.risorsaId)
      .then((_ncCodici: SearchResult<NcCodice>) => this.ncCodici = _ncCodici.result)
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento dei codici NC."))
      .finally(() => this.loading = false);
  };

  selectCodice = (e: SelectCustomEvent) => {
    const idCodNc = +e.target.value;
    this.idCodNCChange.emit(idCodNc);
    const found = this.ncCodici.find(c => c.idCodNc === idCodNc);
    if (found) {
      this.idChange.emit(found.id);
    }
  };
}
